document.addEventListener('DOMContentLoaded', () => {
  const accordionItems = document.querySelectorAll('.accordion-item');

  accordionItems.forEach((item) => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');

    header.addEventListener('click', () => {
      // Toggle the active class on the content
      content.classList.toggle('active');

      // Toggle the active class on the item (controls which icon shows)
      item.classList.toggle('active');

      // Add accessibility attributes
      const expanded = content.classList.contains('active');
      header.setAttribute('aria-expanded', expanded);
      content.setAttribute('aria-hidden', !expanded);
    });

    // Set initial accessibility attributes
    header.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
  });
});
